module.exports = __webpack_public_path__ + "img/gb.1e361bad.svg";